import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import * as breakpoints from '../../../data/breakpoints';
import MaxWidthContainer from '../Containers/MaxWidthContainer';
import UserAvatar from '../Avatars/UserAvatar';

const SignUpMessage = ({ access, author }) => {
  const signupHref = `/signup?plan_type=basic`;
  let message = null;

  if (access.loggedIn === false) {
    message = (
      <div className="sign-up-message fixed-footer-message">
        <MaxWidthContainer>
          <div className="sign-up-message-inner">
            <UserAvatar image={author.image_url} verified={author.the_real_deal} />

            <MediaQuery minWidth={breakpoints.MEDIUM}>
              {(matches) => {
                if (matches) {
                  return <p>Never miss an article from <span className="fw-medium">{author.full_name}</span>, when you sign up to The Coaching Manual. <a href="https://www.thecoachingmanual.com/features" target="_blank" rel="noopener noreferrer">Learn more</a> about the benefits.</p>;
                }
                return <p>Never miss an article from <span className="fw-medium">{author.full_name}</span>, when you sign up to The Coaching Manual.</p>;
              }}
            </MediaQuery>

            <MediaQuery minWidth={breakpoints.MEDIUM}>
              {(matches) => {
                if (matches) {
                  return <a href={signupHref} className="btn">Sign up for free</a>;
                }
                return <a href={signupHref} className="btn btn-S">Sign up</a>;
              }}
            </MediaQuery>
          </div>
        </MaxWidthContainer>
      </div>
    );
  }

  return message;
};

SignUpMessage.propTypes = {
  access: PropTypes.object,
  author: PropTypes.object,
};

export default SignUpMessage;



// WEBPACK FOOTER //
// ./library/app/components/Global/Messages/SignUpMessage.js